<template>
    <div class="ms-3 me-3" :class="{'loading': loading.data}">
        <div class="d-flex flex-row align-items-center mb-3">
            <user-avatar size="large" :user="user"></user-avatar>
            <div class="ms-2">
                <div class="title">{{ user.name }}</div>
                <div class="subtitle" v-if="user.main_caregiver">Hero of <span class="link-primary">{{ user.main_caregiver[0].name }}</span></div>
            </div>
        </div>
        <tabs v-if="user" ref="tabs">
            <tab name="Schedule">
                <calendar-view></calendar-view>
            </tab>
            <tab name="Milestones">
                <div class="row mt-2 p-0">
                    <div class="col-10">
                        <milestones-list></milestones-list>
                    </div>
                    <div class="col-2 mt-2">
                        <div style="margin-bottom: 24px">{{heroBadgesCount}} Badges achieved</div>
                        <div v-for="(badges, key) in badgesGroup" class="hero-badge-card mb-1" @click="viewBadges(badges)">
                            <img src="/assets/img/icons/badge-icon.svg">
                            {{key}} {{badges.length}}/{{totalBadges[key].length}}
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Team Members" ref="teamMembersTab">
                <team-members class="p-0"></team-members>
            </tab>
            <tab name="Card Decks">
                <hero-card-decks :hero-name="user.name"></hero-card-decks>
            </tab>
        </tabs>
        <modal name="viewBadgesModal" height="auto" width="90%" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="w-100 text-left" style="position: relative">
                        <div class="modal-header-icon">
                            <inline-svg src="/assets/img/icons/badge-icon-black.svg"></inline-svg><br>
                        </div>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('viewBadgesModal')"></button>
                    </div>
                </div>
                <div class="modal-subtitle-gray pe-3 mt-2" style="padding-left: 24px">
                    <h4 class="modal-title dashboard-card-title">{{user.name}}'s badges</h4>
                    Badges are sponsored by Inclusion Partners, and achieved by Heroes in the MagnusCards app when a Hero views Card Decks regularly.
                    <br><br>
                    Heroes have a trophy room in the MagnusCards app where they can view all the Badges they collect!
                    <br><br>
                    <strong>Badges are sponsored by Inclusion Partners!</strong>
                </div>
                <div class="modal-body mt-2">
                    <VuePerfectScrollbar style="height: 400px">
                        <div v-for="(badges, key) in badgesGroup" class="mb-4">
                            <div class="m-1"><strong>{{ key }}</strong></div>
                            <SwiperBadges :key="key" class="mt-3" :data="badges" :data_key="key"></SwiperBadges>
                        </div>
                    </VuePerfectScrollbar>
                </div>
                <div class="divider"></div>
                <div class="modal-footer pb-2 pt-2">
                    <btn class="btn-outline-light btn-lg" @click="$modal.hide('viewBadgesModal')">Close</btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import Tabs from "@/components/core/Tabs.vue";
import Tab from "@/components/core/Tab.vue";
import CalendarView from "@/views/CalendarView.vue";
import MilestonesList from "@/components/MilestonesList.vue";
import TeamMembers from "@/views/TeamMembers.vue";
import HeroCardDecks from "@/views/CardDecks/HeroCardDecks.vue";
import SwiperBadges from "@/components/core/SwiperBadges.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "HeroDetails",
  components: {SwiperBadges, HeroCardDecks, TeamMembers, MilestonesList, CalendarView, Tab, Tabs, UserAvatar, VuePerfectScrollbar},
  data() {
    return {
      loading: {
        data: false
      },
      user: {
        name: ''
      },
      badgesGroup: [],
      totalBadges: [],
      heroBadgesCount: 0,
    }
  },
  mounted() {
    this.getUser();
    this.getBadgesGroup();
    if (this.$route.params.addTeamMember) {
      this.$refs.tabs.selectTab(this.$refs.tabs.tabs[2].hash)
    }
  },
  methods: {
    getUser() {
      this.loading.data = true;
      this.$http.post("/hero/get", {id: this.$route.params.hero_id})
        .then((res) => {
          this.user = res.body.data;
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    getBadgesGroup() {
      this.loading.data = true;
      this.$http.post("/hero/badges", {hero_id: this.$route.params.hero_id})
        .then((res) => {
          this.badgesGroup = res.body.data.hero_badges;
          this.totalBadges = res.body.data.total_badges;
          this.heroBadgesCount = res.body.data.hero_badges_count;
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    viewBadges(badges)
    {
      this.$modal.show('viewBadgesModal')
    }
  }
}
</script>

<style scoped>

</style>
